import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
import { useTestIdAttribute, } from '../../hooks/useTestIdAttribute';
const StyledPlainButton = styled('button', (button) => ({
    background: button.$isFocused
        ? staticColors.plainButtonFocusedBackground
        : button.$background || 'none',
    border: 'none',
    padding: 0,
    margin: 0,
    lineHeight: 0,
    textAlign: 'left',
    width: button.$width || 'auto',
    outline: button.$outline || 'none',
    cursor: 'pointer',
    ':disabled': {
        cursor: 'not-allowed',
        opacity: 0.5,
    },
}));
export const PlainButton = forwardRef(({ testId, ...buttonProps }, ref) => {
    const testIdAttribute = useTestIdAttribute(testId);
    return _jsx(StyledPlainButton, { ...buttonProps, ...testIdAttribute, ref: ref });
});
